export default "__VITE_ASSET__B1unUc_P__"